// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../runtime/json/scalar";
import { default as serialize, } from "../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        userId: "0",
        agreeMarketing: false,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.userId !== undefined)
        result.userId = tsValueToJsonValueFns.int64(value.userId);
    if (value.agreeMarketing !== undefined)
        result.agreeMarketing = tsValueToJsonValueFns.bool(value.agreeMarketing);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.userId !== undefined)
        result.userId = jsonValueToTsValueFns.int64(value.userId);
    if (value.agreeMarketing !== undefined)
        result.agreeMarketing = jsonValueToTsValueFns.bool(value.agreeMarketing);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.userId !== undefined) {
        const tsValue = value.userId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.agreeMarketing !== undefined) {
        const tsValue = value.agreeMarketing;
        result.push([2, tsValueToWireValueFns.bool(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.userId = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.bool(wireValue);
        if (value === undefined)
            break field;
        result.agreeMarketing = value;
    }
    return result;
}
